import React from "react";
import {Authorizations, hasAuthorization} from "../../utils/authorizations";
import {sessionStore} from "../../utils/sessionStore";
import {Route} from "react-router-dom";
import {Merchandising} from "../../views/marketplace/merchandising/index";
import RequireAuthentication from "../../hoc/authentication/requireAuthentication";
import EnrichmentPage from "../../views/marketplace/enrichment";

let routes = [];
const applications = sessionStore.get("applications");
const authorizations = sessionStore.get("authorizations") ?? [];

if (applications && applications['marketplace']) {
    if (hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_VIEW) || hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_EDIT) || hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_MANAGEMENT)) {
        routes.push([
            <Route
                component={RequireAuthentication(Merchandising)}
                path="/merchandising/products"
                key="merchandisingProducts"
            />
        ]);
    }

    if (hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_ENRICH)) {
        routes.push([
            <Route
                component={RequireAuthentication(EnrichmentPage)}
                path="/enrichment"
                exact
                key="enrichment"
            />
        ]);
    }
}

export default routes;
